export default __webpack_public_path__ + "static/media/Heavy Duty Platfroms.e0601ad5.jpg";